export const AscentLogo = () => (
  <img width="272" alt="Ascent's logo" src="/images/ascent-logo.jpeg" />
)
